<template>
  <div class="h-[100vh] bg-white flex items-center justify-center">
    <div id="dialog-swiper" ref="swiper" class="swiper">
      <div class="slide-block swiper-wrapper">
        <div v-for="(item, index) in [1,2,3,4]" :key="index" class="swiper-slide">
          <div class="mt-4 text-center swiper-img relative">
<!--            <cover-block class="cover-btn" title="设置图片" />-->
            <img class="inline-block" src="https://kopglobal.com/site-builder/prod/1718070229575_1717661288569_贴脸图.png" alt="" />
          </div>
        </div>
      </div>
      <div class="swiper-pagination relative" />
    </div>
  </div>
</template>

<script>
import { Navigation, Pagination, Swiper } from 'swiper'
import 'swiper/swiper.min.css'
export default {
  components: {

  },
  data() {
    return {
      loading: false
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      const that = this
      this.swiper = new Swiper('.swiper', {
        preventClicks: false,
        loop: false,
        slidesPerView: 1,
        updateOnWindowResize: false,
        resistanceRatio: 0,
        direction: 'horizontal',
        modules: [Navigation, Pagination],
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true
        },
        autoplay: false,
        on: {
          init() {
            that.loading = false
          },
          slideChangeTransitionEnd() {
            that.showRichText = true
          }
        }
      })
    }
  }
}
</script>

<style lang="less">
.swiper {
  width: 500px;
  overflow: hidden;
}
</style>
